import React from 'react'

import {
    action_fetch_product_vo,
    action_fetch_product_summary,
    action_fetch_product_menus,
    action_fetch_ab,
    action_fetch_bottom_banner,
    action_fetch_shop_the_look,
    // action_fetch_product_taglia,
    action_fetch_clog,
} from '../../../store/actions/pages/product'

import NormalPage from './website-page/normal-page';
// import BellePage from './website-page/belle-page';
import Empty from '../listing/components/list/empty';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useQuery } from '../../hooks/common';
import { useParams } from 'react-router-dom';
import { useStore } from 'react-redux';
// import { action_fetch_size_data } from '../../../store/actions/global';
import Cache from '../../../utils/cache';


const ProductPage = props => {
    const global = useSelector(state => state.global)
    const pageProduct = useSelector(state => state.pageProduct)
    const { productVO } = pageProduct;
    const query = useQuery()
    const params = useParams()
    const store = useStore()

    useEffect(() => {
        let recentlyProducts = Cache.get("recently_view_products");
        let productId = params?.id;
        if (recentlyProducts?.length > 0) {
            let newValues = recentlyProducts.filter(item => item !== productId);
            if (recentlyProducts.length < 60) {
                Cache.set("recently_view_products", [productId, ...newValues], (365 * 24 * 60 * 60) * 1000);
            } else {
                let sliceArrs = [productId, ...newValues].slice(0, 60);
                Cache.set("recently_view_products", sliceArrs, (365 * 24 * 60 * 60) * 1000);
            }
        } else {
            Cache.set("recently_view_products", [productId], (365 * 24 * 60 * 60) * 1000);
        }

        if (window.__INITIAL_STATE__) {
            // Allow the passed state to be garbage-collected
            delete window.__INITIAL_STATE__
        } else {
            if (productVO?.selectedProductId !== params?.id) {
                ProductPage.fetchData(store, params, query, null)
            }
        }
    }, [params?.id, query.color])

    return (
        productVO?.products?.length > 0 ?
            (<NormalPage {...props} />) : (<Empty title="Out of Stock" />)

    )
}

ProductPage.fetchData = async (store, params, search, headers) => {
    const id = params.id || search?.productId
    const isGift = search?.product_type == 'gift'
    const isAddOn = search?.product_type == 'addOn'
    const saop=search?.saop;
    let params1 = isAddOn ? { type: 2 } : isGift ? { type: 1 } : null;

    let param2;
    if (search?.utm_source) {
        param2 = !!params1 ? { ...params1, utm_source: search.utm_source } : { utm_source: search.utm_source };
    } else {
        param2 = params1;
    }
    if(saop){
        param2={...param2,saop}
    }
    const fetchProduct = store.dispatch(action_fetch_product_vo(id, param2, headers))
    const fetchReivewSummary = store.dispatch(action_fetch_product_summary(id, headers))
    const fetchCategories = store.dispatch(action_fetch_product_menus(id, headers))
    const fetchAb = store.dispatch(action_fetch_ab(headers))
    const fetchBottomBanner = store.dispatch(action_fetch_bottom_banner(headers))
    const fetchShopTheLook = store.dispatch(action_fetch_shop_the_look(id, headers))
    // const fetchTaglia = store.dispatch(action_fetch_product_taglia(id, headers))
    // fetchTaglia
    const fetchClog = store.dispatch(action_fetch_clog({productId: id, skip:0, limit:20}, headers))
    const values = await Promise.all([fetchProduct, fetchReivewSummary, fetchCategories, fetchAb, fetchBottomBanner, fetchShopTheLook, fetchClog])
    return values
}

export default ProductPage